var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WMLogger } from '@mobilize/logging';
import { Order } from '../../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var PointerBehavior = (function () {
    function PointerBehavior() {
    }
    PointerBehavior.prototype.apply = function (model, root) {
        if (model.isPointer) {
            var value = void 0;
            if (model['p']) {
                value = model['p'];
            }
            else if (model['v']) {
                value = model['v'];
            }
            var parent_1 = root.getParentByModel(model);
            if (model['p']) {
                var pointedObject = root.getModel(value);
                if (pointedObject) {
                    pointedObject.addPointerId(parent_1.UniqueID, model.UniqueID);
                    parent_1.addReference(model.uniqueName(), pointedObject);
                }
                else {
                    WMLogger.instance().error("PointerBehavior: Unable to find model ".concat(value, " in the model buffer, pointed by model ").concat(model.UniqueID));
                }
            }
            else if (model['v']) {
                parent_1.addValue(model.uniqueName(), value);
            }
        }
    };
    Object.defineProperty(PointerBehavior.prototype, "Order", {
        get: function () {
            return Order.ORD;
        },
        enumerable: false,
        configurable: true
    });
    PointerBehavior = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore)
    ], PointerBehavior);
    return PointerBehavior;
}());
export { PointerBehavior };
